import { ReactNode } from "react";

export function renderComNegrito(texto?: string | null): ReactNode[] {
  if (!texto) return [];

  const partes: ReactNode[] = [];
  const regex = /<(b|strong)>([\s\S]*?)<\/\1>|<br\s*\/?>/gi;
  let ultimoIndice = 0;
  let chave = 0;
  let match: RegExpExecArray | null;

  while ((match = regex.exec(texto)) !== null) {
    if (match.index > ultimoIndice) {
      partes.push(texto.slice(ultimoIndice, match.index));
    }
    if (match[1]) {
      partes.push(<strong key={chave++}>{match[2]}</strong>);
    } else {
      partes.push(<br key={chave++} />);
    }
    ultimoIndice = regex.lastIndex;
  }

  if (ultimoIndice < texto.length) {
    partes.push(texto.slice(ultimoIndice));
  }

  return partes;
}
